// These are from style guide https://www.figma.com/design/riOZDOlKA620gf28gVQTwW/SureCo-Website-2023?node-id=9134-13141

export const titleFontFamily = "'Rocky', 'Helvetica Now Display', sans-serif"
export const defaultFontFamily =
  'SF Pro Text,Helvetica Now Display,  sans-serif'

// Display font — Fraunces is the primary display typeface (loaded via @font-face in the design system).
// Rocky is the fallback for environments where Fraunces is unavailable.
export const displayFontFamily =
  "'Fraunces', 'Rocky', Georgia, 'Times New Roman', serif"
